import React, { useState, createRef, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { Modal } from "react-responsive-modal";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import newOrderService from "../services/new-order-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { Multiselect } from "multiselect-react-dropdown";

import Loader from "react-loader-spinner";
const tablePropsInit = {
  columns: [
    { key: "drg_name", title: "Drug Name" },
    { key: "pat_name", title: "Patient Name" },
    { key: "fac_name", title: "Facility Name" },
    { key: "rxf_ord_sig", title: "Sig" },
    { key: "days_supply", title: "Days Supply" },
    { key: "notes", title: "Clinical Alternative" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const NonFormListSuggestion = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [drg_name, setDrugName] = useState([]);
  const [drgList, setDrugList] = useState([]);

  const getDrugList = async (search) => {
    if (search.trim().length >= 2) {
      try {
        let response = await newOrderService.getDrugs(search);
        let dList = response?.map((item) => {
          item.dname = item.dname + " " + item.strength + " " + item.dos_id;
          return item;
        });

        setDrugList([]);
        setDrugList(dList);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving drugs. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  };

  const CustomCell = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          <button
            className="text-white w-full sm:w-auto h-9 px-6  mt-2 sm:mt-5 bg-login_btn rounded text-xs font-medium capitalize focus:outline-none"
            onClick={() => {
              setOpenPopUp(true);
              setSuggestion(rowData?.suggestion);
              setSelectedItem(rowData);
              setFrequency([]);
              setQty("");
              setDrugName([]);
            }}
          >
            EDIT
          </button>
        </span>
      </div>
    );
  };
  const onSubmit = async (data, rowDta) => {
    try {
      setLoading(true);
      rowDta["notes"] = data;
      rowDta["alt_frequency"] =  frequency?.length  > 0  ? frequency[0]?.dcode : null;
      rowDta["alt_qty_dose"] = qty;
      rowDta["status"] = "T";
      rowDta["alt_drg_id"] = drg_name?.length > 0 ? drg_name[0]?.id : null;
      if(!qty){
        delete rowDta.alt_qty_dose
      }
      await newOrderService.submitSuggestion(rowDta?.id, rowDta);
      setOpenPopUp(false);
      let resp = await newOrderService.getNonFormsComments();
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      dispatch(updateData(resp));
      setSelectedItem({});
      setSuggestion("");
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting suggestion. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await newOrderService.getNonFormsComments();
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatch(updateData(resp));
    }
  };
  const [openPopUp, setOpenPopUp] = useState(false);
  const [suggestion, setSuggestion] = useState("");
  const [seletedItem, setSelectedItem] = useState({});
  const onCloseModal = async () => {
    setOpenPopUp(false);
    setSelectedItem({});
    setSuggestion("");
  };
  const multiselectRefDrug = createRef();
  const multiselectRefFrequency = createRef();

  const [qty, setQty] = useState("");
  const [frequencyList, setFrequencyList] = useState([]);
  const [frequency, setFrequency] = useState("");
  const getFrequencyList = async () => {
    try {
      let response = await newOrderService.getFrequency();
      setFrequencyList([]);
      setFrequencyList(response);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving frequency. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  useEffect(() => {
    getFrequencyList();
  }, []);

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={openPopUp} onClose={onCloseModal} center>
        <div className="pt-4 px-8 pb-4 w-96 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Suggestion
          </h3>
          <div className="bg-white mt-4 rounded ">
            <div className="text-xs">
              <ul>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Drug Name
                  </label>

                  {drgList ? (
                    <Multiselect
                      name="drgList"
                      displayValue="dname"
                      selectedValues={drg_name}
                      options={drgList}
                      ref={multiselectRefDrug}
                      avoidHighlightFirstOption={true}
                      selectionLimit={1}
                      hidePlaceholder={true}
                      caseSensitiveSearch={true}
                      onSelect={(selectedList, selectedItem) => {
                        setDrugName([selectedItem]);
                      }}
                      onSearch={(value) => {
                        getDrugList(value);
                      }}
                      onRemove={() => {
                        setDrugName([]);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </li>
               
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Quantity per dose
                  </label>
                  <input
                    id="qty"
                    name="qty"
                    type="number"
                    placeholder="Quantity"
                    value={qty}
                    onChange={(e) =>
                      setQty(e.target.value ? Math.abs(e.target.value) : null)
                    }
                    className={` 
                    border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Frequency
                  </label>
                  {frequencyList ? (
                    <Multiselect
                      name="frequencyList"
                      displayValue="dcode"
                      selectedValues={frequency}
                      options={frequencyList}
                      ref={multiselectRefFrequency}
                      avoidHighlightFirstOption={true}
                      selectionLimit={1}
                      hidePlaceholder={true}
                      onSelect={(selectedList, selectedItem) => {
                        setFrequency([selectedItem]);
                      }}
                      onRemove={() => {
                        setFrequency([]);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Notes
                  </label>
                  <textarea
                    id="suggestion"
                    name="suggestion"
                    type="text"
                    placeholder="Enter your suggestion"
                    value={suggestion}
                    onChange={(e) => setSuggestion(e.target.value)}
                    className={`border focus:outline-none p-2 h-24  rounded-md  font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
              </ul>
            </div>
          </div>

          <div className="flex justify-center">
            <button
              onClick={() => {
                onSubmit(suggestion, seletedItem);
              }}
              type="button"
              className="mr-2 rounded text-sm font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Submit
            </button>

            <button
              onClick={onCloseModal}
              type="button"
              className="rounded  text-sm font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">NON FORMS CLINICAL ALTERNATIVES</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4  right-5  bottom-3"
              ></img>
            </span>
          </div>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(NonFormListSuggestion)
);
